import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import galleryIcon from "../../../src/assests/images/gallaryIcon.svg";
import Upload from "../../../src/assests/images/document-upload.svg";

import { getToken } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { uploadimagetask } from "../../pages/create-task/api";
import { useTaskContext } from "../store/AlltasksContext";
import LinearProgress from "@mui/material/LinearProgress";

function CreatetaskImg({
  setuploadedImage,
  id,
  headTitle,
  title,
  subtitle,
  note,
  uploadText,
  maintitle,
  handleAction,
  uploadSize,
  addMoreText,
  onClick,
  imageUrls = [],
  lang,
}: any) {
  const [keyVisualFiles, setKeyVisualFiles] = useState<
    { id: number; file: File; preview: string; imageUrl?: string }[]
  >([]);
  const navigate = useNavigate();
  const [isUploading, setIsUploading] = useState(false);

  const [mainid, setmainid] = useState<number | null>(null);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploadProgress, setUploadProgress] = useState<{
    [fileName: string]: number;
  }>({});

  const token = getToken();
  const {
    setimagesdata,
    imagesdata,
    Tabname,
    files,
    setFiles,
    defaultipostermages,
    setdefaultipostermages
  } = useTaskContext();

  useEffect(() => {
    setimagesdata([]);
  }, [Tabname]);



  useEffect(() => {
  if (defaultipostermages && defaultipostermages.length > 0) {
    setimagesdata([
      {
        id: id,
        images: defaultipostermages,
      },
    ]);
  } else {
    setimagesdata([]);
  }
}, [defaultipostermages, id, setimagesdata]);

console.log(defaultipostermages, "defaultipostermageseeeeeeee",imagesdata, "imagesdata4444444")
  const handleDrop = async (
    acceptedFiles: File[],
    setter: React.Dispatch<
      React.SetStateAction<
        { id: number; file: File; preview: string; imageUrl?: string }[]
      >
    >,
    id: number
  ) => {
    if (acceptedFiles.length === 0 || mainid === null) return;

    setIsUploading(true);
    setUploadError(null);

    try {
      const uploadedFiles = await Promise.all(
        acceptedFiles.map(async (file) => {
          const formData = new FormData();
          formData.append("answer", file);

          const response = await uploadimagetask(formData, token);

          if (response?.data?.answer) {
            return {
              id: mainid,
              file,
              preview: URL.createObjectURL(file),
              imageUrl: response.data.answer,
            };
          } else {
            return null;
          }
        })
      );

      const successfulUploads = uploadedFiles.filter(
        (file): file is { id: number; file: File; preview: string; imageUrl: string } =>
          file !== null
      );

      setimagesdata((prevImagesData) => {
  const existingEntry = prevImagesData.find((entry) => entry.id === mainid);

  // remove null/undefined/empty string before storing
  const validUploads = successfulUploads
    .map((file) => file.imageUrl)
    .filter((url) => url); 

  if (existingEntry) {
    return prevImagesData.map((entry) =>
      entry.id === mainid
        ? {
            ...entry,
            images: [
              ...entry.images.filter((url) => url), // ✅ keep only valid ones
              ...validUploads,
            ],
          }
        : entry
    );
  } else {
    return [
      ...prevImagesData,
      {
        id: mainid,
        images: validUploads,
      },
    ];
  }
});


      setter((prev) => [...prev, ...successfulUploads]);
    } catch (error) {
      console.error("Upload error:", error);
      setUploadError("Upload failed. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  // const handleRemoveFile = (
  //   index: number,
  //   setter: React.Dispatch<
  //     React.SetStateAction<
  //       { id: number; file: File; preview: string; imageUrl?: string }[]
  //     >
  //   >,
  //   mainid: number
  // ) => {
  //   setter((prev) => {
  //     const updatedFiles = prev.filter((_, i) => i !== index);

  //     setimagesdata((prevImagesData) => {
  //       return prevImagesData
  //         .map((entry) =>
  //           entry.id === mainid
  //             ? { ...entry, images: entry.images.filter((_, i) => i !== index) }
  //             : entry
  //         )
  //         .filter((entry) => entry.images.length > 0);
  //     });

  //     return updatedFiles;
  //   });
  // };

  const handleBoxClick = () => {
    setmainid(id);
  };

  // const renderThumbnails = (
  //   files: { file: File; preview: string }[],
  //   setter: any,
  //   mainid: number
  // ) =>
    // files.map((file: any, index: number) => {
    //   const isVideo =
    //     file.file && file.file.type
    //       ? file.file.type.startsWith("video")
    //       : false;
    //   const progress = uploadProgress[file.file?.name || file.preview];
    //   return (
    //     <Box
    //       key={index}
    //       sx={{
    //         position: "relative",
    //         width: 100,
    //         height: 100,
    //         margin: 1,
    //         border: "1px solid #ccc",
    //         borderRadius: 2,
    //         overflow: "hidden",
    //       }}
    //     >
    //       {isVideo ? (
    //         <video
    //           src={file.preview}
    //           controls
    //           style={{ width: "100%", height: "100%", objectFit: "cover" }}
    //         />
    //       ) : (
    //         <img
    //           src={file.preview}
    //           alt="Preview"
    //           style={{ width: "100%", height: "100%", objectFit: "cover" }}
    //         />
    //       )}
    //       <Button
    //         size="small"
    //         variant="contained"
    //         color="error"
    //         sx={{
    //           position: "absolute",
    //           top: 5,
    //           right: 5,
    //           minWidth: 24,
    //           width: 24,
    //           height: 24,
    //           padding: 0,
    //           borderRadius: "50%",
    //         }}
    //         onClick={() => handleRemoveFile(index, setter, mainid)}
    //       >
    //         ×
    //       </Button>
    //       {progress !== undefined && (
    //         <Box
    //           sx={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}
    //         >
    //           <LinearProgress
    //             variant="determinate"
    //             value={progress}
    //             sx={{ height: 6, borderRadius: 0 }}
    //           />
    //           <Typography
    //             sx={{
    //               position: "absolute",
    //               bottom: 8,
    //               right: 8,
    //               backgroundColor: "rgba(0,0,0,0.6)",
    //               color: "#fff",
    //               fontSize: "12px",
    //               padding: "2px 6px",
    //               borderRadius: "4px",
    //             }}
    //           >
    //             {progress}%
    //           </Typography>
    //         </Box>
    //       )}
    //     </Box>
    //   );
    // });



    const handleRemoveFile = (
  index: number,
  setter: React.Dispatch<
    React.SetStateAction<
      { id: number; file?: File; preview?: string; imageUrl?: string }[]
    >
  >,
  mainid: number
) => {
  setter((prev) => {
    const updatedFiles = prev.filter((_, i) => i !== index);

    setimagesdata((prevImagesData) => {
      return prevImagesData
        .map((entry) =>
          entry.id === mainid
            ? { ...entry, images: entry.images.filter((_, i) => i !== index) }
            : entry
        )
        .filter((entry) => entry.images.length > 0);
    });

    // remove also from defaultipostermages
    setdefaultipostermages((prevDefaults) =>
      prevDefaults.filter((_, i) => i !== index)
    );

    return updatedFiles;
  });
};


    const renderThumbnails = (
  files: { file?: File; preview?: string; imageUrl?: string }[],
  setter: any,
  mainid: number
) =>
  files.map((file: any, index: number) => {
    const imgSrc = file.preview || file.imageUrl;
     const isVideo =
        file.file && file.file.type
          ? file.file.type.startsWith("video")
          : false;
    const progress = uploadProgress[file.file?.name || file.preview];

    return (
      <Box
        key={index}
        sx={{
          position: "relative",
          width: 100,
          height: 100,
          margin: 1,
          border: "1px solid #ccc",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
{isVideo ? (
            <video
              src={file.preview}
              controls
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <img
              src={imgSrc}
              alt="Preview"
              crossOrigin="anonymous"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}       
        <Button
          size="small"
          variant="contained"
          color="error"
          sx={{
            position: "absolute",
            top: 5,
            right: 5,
            minWidth: 24,
            width: 24,
            height: 24,
            padding: 0,
            borderRadius: "50%",
          }}
          onClick={() => handleRemoveFile(index, setter, mainid)}
        >
          ×
        </Button>

        {progress !== undefined && (
          <Box
            sx={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}
          >
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{ height: 6, borderRadius: 0 }}
            />
            <Typography
              sx={{
                position: "absolute",
                bottom: 8,
                right: 8,
                backgroundColor: "rgba(0,0,0,0.6)",
                color: "#fff",
                fontSize: "12px",
                padding: "2px 6px",
                borderRadius: "4px",
              }}
            >
              {progress}%
            </Typography>
          </Box>
        )}
      </Box>
    );
  });

  const { getRootProps: getRootPropsMain, getInputProps: getInputPropsMain } =
    useDropzone({
      onDrop: (files: File[], fileRejections: any[]) => {
        setUploadError(null);

        if (fileRejections.length > 0) {
          fileRejections.forEach((rej) => {
            if (rej.errors[0].message) {
              setUploadError(rej.errors[0].message);
            }
          });
          return;
        }

        if (files.length > 0) {
          handleDrop(files, setFiles, 1);
        }
      },
      accept: { "image/*": [], "video/*": [] },
      multiple: false,
      // ✅ Custom validator for different size limits
      validator: (file: File) => {
        if (file.type.startsWith("image") && file.size > 5 * 1024 * 1024) {
          return {
            code: "too-large",
            message: "Image size must not exceed 5MB",
          };
        }
        if (file.type.startsWith("video") && file.size > 10 * 1024 * 1024) {
          return {
            code: "too-large",
            message: "Video size must not exceed 10MB",
          };
        }
        return null;
      },
    });
useEffect(() => {
  if (Array.isArray(defaultipostermages) && defaultipostermages.length > 0) {
    setimagesdata([
      {
        id,
        images: defaultipostermages.filter((url) => url), // ✅ filter invalid
      },
    ]);
  } else {
    setimagesdata([]);
  }
}, [defaultipostermages, id, setimagesdata]);


  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: "0 0px" }}>
      <Typography
        variant="h3"
        sx={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#000",
          margin: "20px 0 20px",
          width: "100%",
        }}
      >
        {headTitle}
      </Typography>
      <Typography variant="h6" sx={{ fontSize: "18px", display: "flex" }}>
        <img
          style={{ marginRight: "8px", marginTop: "0px" }}
          src={Upload}
          alt="upload image"
        />
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ fontSize: "16px", fontWeight: "400", color: "#696A6B" }}
      >
        {subtitle}
      </Typography>
      <Box sx={{ display: "flex" }}>
        <Box
          {...getRootPropsMain({ onClick: handleBoxClick })}
          sx={{
            mt: 2,
            border: "2px dashed #ccc",
            padding: 3,
            borderRadius: 2,
            textAlign: "center",
            cursor: "pointer",
            height: "200px",
            background: "#fff",
            paddingTop: "40px",
            width: "70%",
            marginRight: "30px",
          }}
        >
          <input {...getInputPropsMain()} />
          <img src={galleryIcon} alt="Gallery Icon" />
          <Typography sx={{ fontSize: "16px" }}>{uploadText}</Typography>
          <Typography sx={{ fontSize: "14px", color: "#7D7E7F" }}>
            {uploadSize}
          </Typography>
        </Box>
      </Box>
      {uploadError && (
        <Typography sx={{ color: "red", mt: 1 }}>{uploadError}</Typography>
      )}
      {/* <Box
        onClick={() => handleAction && handleAction(id)}
        sx={{ display: "flex", mt: 2, flexWrap: "wrap" }}
      >
        {renderThumbnails(files, setFiles, mainid || 0)}
      </Box> */}

      <Box
  onClick={() => handleAction && handleAction(id)}
  sx={{ display: "flex", mt: 2, flexWrap: "wrap" }}
>
  {renderThumbnails(
    [
      ...files.filter((f) => f), // ✅ remove null/undefined from files
      ...(
        Array.isArray(defaultipostermages) 
          ? defaultipostermages.filter((url) => url) // ✅ remove null/undefined/empty string
          : []
      ).map((url) => ({ imageUrl: url })),
    ],
    setFiles,
    mainid || 0
  )}
</Box>



      <Typography variant="body1" sx={{ display: "flex" }}>
        {imageUrls.length > 0 ? (
          imageUrls.map((url: any, index: any) => (
            <img
              key={index}
              src={url}
              alt={`Image ${index + 1}`}
              className="uploaded-image-preview"
            />
          ))
        ) : (
          <p></p>
        )}
        {note}
      </Typography>
    </Box>
  );
}

export default CreatetaskImg;